import React from 'react';
import { FiSliders, FiShield, FiGlobe, FiLock, FiDollarSign, FiFileText } from 'react-icons/fi';

const AdminSettings = () => {
    return (
        <div className="animate-fade">
            <h1 style={{ marginBottom: '2rem' }}>Pricing & Rules</h1>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                {/* Pricing Rules */}
                <div className="card" style={{ padding: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
                        <FiDollarSign color="var(--primary)" size={24} />
                        <h2 style={{ margin: 0 }}>Pricing Engine</h2>
                    </div>

                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Base Rate (USD/min)</label>
                        <input value="0.50" disabled style={{ background: 'rgba(255,255,255,0.05)', color: 'white' }} />
                    </div>

                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Bridge Multiplier</label>
                        <input value="2.0" disabled style={{ background: 'rgba(255,255,255,0.05)', color: 'white' }} />
                    </div>

                    <button className="primary" disabled style={{ width: '100%', opacity: 0.5 }}>Save Pricing Model</button>
                    <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '1rem', textAlign: 'center' }}>
                        Rate updates require manual deployment in current version.
                    </p>
                </div>

                {/* Abuse Controls */}
                <div className="card" style={{ padding: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
                        <FiShield color="var(--danger)" size={24} />
                        <h2 style={{ margin: 0 }}>Anti-Abuse</h2>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', padding: '1rem', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
                        <div>
                            <div style={{ fontWeight: 600 }}>Emergency Call Blocking</div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Blocks 911, 112, etc.</div>
                        </div>
                        <div style={{ color: 'var(--success)', fontWeight: 700 }}>ACTIVE</div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', padding: '1rem', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
                        <div>
                            <div style={{ fontWeight: 600 }}>Velocity Checks</div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Limit calls per 24h</div>
                        </div>
                        <div style={{ color: 'var(--warning)', fontWeight: 700 }}>DEV MODE</div>
                    </div>
                </div>

                {/* Destination Controls */}
                <div className="card" style={{ padding: '2rem', gridColumn: 'span 2' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
                        <FiGlobe color="var(--primary)" size={24} />
                        <h2 style={{ margin: 0 }}>Destination Gatekeeper</h2>
                    </div>
                    <p style={{ color: 'var(--text-muted)' }}>
                        Currently using hardcoded <code>numberValidator.js</code> rules.
                        Dynamic prefix management interface is being optimized for low-latency lookups.
                    </p>
                </div>

                {/* Legal & Compliance */}
                <div className="card" style={{ padding: '2rem', gridColumn: 'span 2' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
                        <FiFileText color="var(--primary)" size={24} />
                        <h2 style={{ margin: 0 }}>Legal Configuration</h2>
                    </div>

                    <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
                        Manage the URL for your unified legal page (Privacy Policy, Terms, and Refund Policy).
                    </p>

                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                            Legal Page URL <span style={{ color: 'var(--danger)' }}>*</span>
                        </label>
                        <input
                            placeholder="www.website.com/privacy"
                            defaultValue="www.website.com/privacy"
                            style={{ width: '100%', padding: '0.75rem', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: 'white' }}
                        />
                        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
                            This link is used for all "Terms", "Privacy", and "Refund" footer links.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;
